import { AnalyticsEventProperties } from 'core/analytics/analytics-types'
import { HomepageEvent } from 'core/constants/homepage-analytics'
import { trackAnalyticsEvent } from 'core/hooks/useAnalytics'

export const trackHomepageEvent = (event: HomepageEvent, properties?: AnalyticsEventProperties) => {
  trackAnalyticsEvent(event, properties)
}
